module.exports = "<a class=\"_back\" (click)=\"onContinue()\"></a><app-tips (continue)=\"onCancel()\" (close)=\"onClose()\"></app-tips>";